<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-top">
        <div class="footer-top-left">
          <div class="footer-logo" @click="navigate('/')">
            <img src="../static/home/logo.png" alt="logo" />
          </div>
          <div class="footer-contact">
            <div class="contact-item-phone">
              <img src="../static/home/phone.png" alt="phone" />
              <span>0512-63390858</span>
            </div>
            <div class="contact-item-address">
              <span>江苏省苏州市吴江经济技术开发区庞金路1801号 庞金工业坊9幢 </span>
            </div>
            <div class="contact-item-email">
              <span>marketing@xinghanmaterials.com</span>
            </div>
          </div>
        </div>

        <div class="footer-top-right">
          <div class="link-column">
            <h3>关于星翰</h3>
            <ul>
              <li><a @click.prevent="navigate('/about')">公司简介</a></li>
              <li><a @click.prevent="navigate('/about', '#culture')">企业文化</a></li>
              <li><a @click.prevent="navigate('/about', '#cooperation')">合作共赢</a></li>
              <li><a @click.prevent="navigate('/about', '#honors')">资质荣誉</a></li>
              <li><a @click.prevent="navigate('/about', '#history')">发展历程</a></li>
            </ul>
          </div>
          <div class="link-column">
            <h3>科研实力</h3>
            <ul>
              <li><a @click.prevent="navigate('/rd')">实验与设备</a></li>
              <li><a @click.prevent="navigate('/rd', '#cooperation-rd')">产学研合作</a></li>
              <li><a @click.prevent="navigate('/rd', '#patents')">专利与认证</a></li>
            </ul>
          </div>
          <div class="link-column">
            <h3>解决方案</h3>
            <ul>
              <li><a @click.prevent="navigate('/solutions?type=guangfu')">光伏新能源</a></li>
              <li><a @click.prevent="navigate('/solutions?type=bandaoti')">泛半导体</a></li>
            </ul>
          </div>
          <div class="link-column">
            <h3>新闻动态</h3>
            <ul>
              <li><a @click.prevent="navigate('/news?type=gongsi')">公司动态</a></li>
              <li><a @click.prevent="navigate('/news?type=hangye')">行业资讯</a></li>
            </ul>
          </div>
          <div class="link-column">
            <h3>招贤纳士</h3>
            <ul>
              <li><a @click.prevent="navigate('/jobs')">公司概况</a></li>
              <li><a @click.prevent="navigate('/jobs', '#good')">优势福利</a></li>
              <li><a @click.prevent="navigate('/jobs', '#life')">工作生活</a></li>
              <li><a @click.prevent="navigate('/jobs', '#job')">招聘职位</a></li>
            </ul>
          </div>
          <div class="link-column">
            <h3>联系我们</h3>
            <ul>
              <li><a @click.prevent="navigate('/contact')">苏州星翰</a></li>
              <li><a @click.prevent="navigate('/contact')">济源星翰</a></li>
              <li><a @click.prevent="navigate('/contact')">深圳星翰</a></li>
            </ul>
          </div>
        </div>

        <div class="footer-top-right-mobile">
          <div class="link-column">
            <h3>关于星翰</h3>
            <ul>
              <li><a @click.prevent="navigate('/about')">公司简介</a></li>
              <li><a @click.prevent="navigate('/about', '#culture')">企业文化</a></li>
              <li><a @click.prevent="navigate('/about', '#cooperation')">合作共赢</a></li>
              <li><a @click.prevent="navigate('/about', '#honors')">资质荣誉</a></li>
              <li><a @click.prevent="navigate('/about', '#history')">发展历程</a></li>
            </ul>
          </div>
          <div class="link-column">
            <h3>科研实力</h3>
            <ul>
              <li><a @click.prevent="navigate('/rd')">实验与设备</a></li>
              <li><a @click.prevent="navigate('/rd', '#cooperation-rd')">产学研合作</a></li>
              <li><a @click.prevent="navigate('/rd', '#patents')">专利与认证</a></li>
            </ul>
          </div>
          <div class="link-column">
            <h3>解决方案</h3>
            <ul>
              <li><a @click.prevent="navigate('/solutions?type=guangfu')">光伏新能源</a></li>
              <li><a @click.prevent="navigate('/solutions?type=bandaoti')">泛半导体</a></li>
            </ul>
          </div>
          <div class="link-column">
            <h3>联系我们</h3>
            <ul>
              <li><a @click.prevent="navigate('/contact')">苏州星翰</a></li>
              <li><a @click.prevent="navigate('/contact')">济源星翰</a></li>
              <li><a @click.prevent="navigate('/contact')">深圳星翰</a></li>
            </ul>
          </div>
        </div>
      </div>

    </div>
    <div class="footer-container-copyright">
      <div class="footer-bottom">
        <p>Copyright © 2023 Sinchance.com All Rights Reserved</p>
        <p><a target="_blank"  href="http://www.morefancy.cn">苏ICP备2024126489号-1 | 技术支持:Morefancy</a></p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    navigate(path, hash = '') {
      // 如果当前路径与目标路径不同，则进行跳转
      if (this.$route.fullPath !== path && this.$route.path !== path ) {
        this.$router.push({ path, hash });
      }
      // 如果是当前页面但hash不同，则允许锚点跳转
      else if (this.$route.hash !== hash) {
        // 直接修改URL的hash部分以跳转到指定位置
        this.$router.push({ path, hash });
      }
    }
  }
}
</script>

<style lang="less" scoped>
// pc
@media (min-width: 751px) {
  .footer {
    background: #2B2B2B;
    color: #fff;
  }

  .footer-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 40px;

    .footer-top {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 100px 0;

      .footer-top-left {
        display: flex;
        flex-direction: column;

        .footer-logo {
          margin-bottom: 107px;

          img {
            width: 251px;
            height: 41px;
          }
        }

        .footer-contact {
          display: flex;
          flex-direction: column;
          max-width: 320px;

          .contact-item-phone {
            margin-bottom: 34px;
            font-weight: 500;
            font-size: 38px;
            color: #676767;

            img {
              width: 34px;
              height: 29px;
              margin-right: 14px;
            }

            span {
              white-space: nowrap;
            }
          }

          .contact-item-address,
          .contact-item-email {
            font-size: 14px;
            color: #707070;
            line-height: 22px;
          }
        }

      }

      .footer-top-right {
        cursor: pointer;
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        gap: 72px;

        h3 {
          white-space: nowrap;
          margin-bottom: 30px;
          font-weight: 500;
          font-size: 16px;
          color: #fff;
        }

        ul {
          list-style: none;

          li {
            margin-bottom: 12px;

            a {
              text-decoration: none;
              font-size: 14px;
              color: #707070;
              transition: color 0.3s ease;
            }

            a:hover {
              // color: #409eff;
            }
          }
        }
      }
      .footer-top-right-mobile{
        display: none;
      }
    }
  }

  .footer-container-copyright {
    border-top: 1px solid #313640;

    .footer-bottom {
      max-width: 1400px;
      margin: 0 auto;
      padding: 0 40px;
      // height: 50px;
      line-height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      color: #707070;

      a {
        text-decoration: none;
        font-size: 12px;
        color: #707070;
      }
    }
  }
}

// mobile
@media (max-width: 750px) {
  .footer {
    background: #2B2B2B;
    color: #fff;
  }

  .footer-container {
    padding: 0 24px;

    .footer-top {
      display: flex;
      flex-direction: column;
      gap: 36px;
      align-items: flex-start;
      justify-content: space-between;
      padding: 50px 0;

      .footer-top-left {
        display: flex;
        flex-direction: column;

        .footer-logo {
          margin-bottom: 47px;

          img {
            width: 125;
            height: 20px;
          }
        }

        .footer-contact {
          display: flex;
          flex-direction: column;

          .contact-item-phone {
            margin-bottom: 17px;
            font-weight: 500;
            font-size: 19px;
            color: #676767;

            img {
              width: 17px;
              height: 15px;
              margin-right: 7px;
            }

            span {
              white-space: nowrap;
            }
          }

          .contact-item-address,
          .contact-item-email {
            font-size: 11px;
            color: #707070;
            line-height: 22px;
          }
        }

      }

      .footer-top-right {
        display: none;
      }
      .footer-top-right-mobile {
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        cursor: pointer;

        h3 {
          white-space: nowrap;
          margin-bottom: 15px;
          font-weight: 500;
          font-size: 14px;
          color: #fff;
        }

        ul {
          list-style: none;

          li {
            margin-bottom: 12px;

            a {
              white-space: nowrap;
              text-decoration: none;
              font-size: 12px;
              color: #707070;
              transition: color 0.3s ease;
            }
          }
        }
      }
    }
  }

  .footer-container-copyright {
    border-top: 1px solid #313640;

    .footer-bottom {
      padding: 20px 24px ;
      line-height: 25px;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 10px;
      color: #707070;

      a {
        text-decoration: none;
        font-size: 10px;
        color: #707070;
      }
    }
  }
}
</style>
